import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui-kit/src/components/molecules/AuthenticationHandler/AuthenticationHandler.component.tsx");
